/* Age gate (18+) verification */
(function () {
  'use strict';

  const modal = document.getElementById('age-gate');
  if (!modal) return;

  const COOKIE_NAME = 'intimum_age_verified';
  const COOKIE_DAYS = parseInt(modal.closest('[data-section-id]')?.dataset?.cookieDays || '30', 10);

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  if (getCookie(COOKIE_NAME) === '1') {
    modal.remove();
    return;
  }

  modal.classList.add('is-active');
  document.body.style.overflow = 'hidden';

  document.getElementById('age-gate-confirm')?.addEventListener('click', function () {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
    setTimeout(function () { modal.remove(); }, 400);
  });
})();
